import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { forgotPasswordRequest } from '@/api/auth';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await forgotPasswordRequest(email);
      setSubmitted(true);
      toast.success(t('auth.resetEmailSent'));
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Request failed';
      toast.error(message);
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="card w-full max-w-md p-8 text-center">
          <h1 className="text-2xl font-bold mb-2">{t('auth.checkInbox')}</h1>
          <p className="text-sm text-slate-600 dark:text-slate-400 mb-6">
            {t('auth.resetEmailSentHelp')}
          </p>
          <Link to="/login" className="btn-secondary">
            {t('auth.backToLogin')}
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="card w-full max-w-md p-8">
        <h1 className="text-2xl font-bold mb-1">{t('auth.forgotTitle')}</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">{t('auth.forgotSubtitle')}</p>

        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          <div>
            <label htmlFor="email" className="block text-sm font-medium mb-1">
              {t('auth.email')}
            </label>
            <input
              id="email"
              type="email"
              autoComplete="email"
              required
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={submitting || !email}>
            {submitting ? t('common.loading') : t('auth.sendResetLink')}
          </button>
          <p className="text-sm text-center text-slate-500">
            <Link to="/login" className="text-brand-600 dark:text-brand-400 hover:underline">
              {t('auth.backToLogin')}
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
}
